import { registerModal } from 'features/Modal/ModalRegistry'
import NumbersChangeUsagePlanModal from './NumbersChangeUsagePlanModal.container'
import { showModal } from 'features/Modal/Modal.actions'

export const modalType = 'NUMBER_CHANGE_USAGE_PLAN'
registerModal(modalType, NumbersChangeUsagePlanModal)
export default modalProps =>
  showModal({
    modalType,
    modalProps,
  })



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersChangeUsagePlanModal/NumbersChangeUsagePlanModal.action.js